import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

/**
 * 可复用的团队成员卡片组件
 * 将原来重复的卡片结构抽象为单独的组件
 */
const TeamCard = (props) => {
  const {
    authorAlt,
    authorSrc,
    authorName,
    authorPosition,
    review,
    className,
    imageClassName,
    textClassName,
    defaultName,
    defaultPosition,
    defaultReview
  } = props

  return (
    <div className="thq-animated-card-bg-2">
      <div className="thq-animated-card-bg-1">
        <div data-animated="true" className={`thq-card ${className}`}>
          <div className={`testimonial17-container12 ${props.containerClassName}`}>
            <img
              alt={authorAlt}
              src={authorSrc}
              className={imageClassName}
            />
            <div className={props.infoContainerClassName}>
              <strong className="thq-body-large">
                {authorName ?? (
                  <Fragment>
                    <span>{defaultName}</span>
                  </Fragment>
                )}
              </strong>
              <span className="thq-body-small">
                {authorPosition ?? (
                  <Fragment>
                    <span>{defaultPosition}</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <span className={`${textClassName} thq-body-small`}>
            {review ?? (
              <Fragment>
                <span>{defaultReview}</span>
              </Fragment>
            )}
          </span>
        </div>
      </div>
    </div>
  )
}

TeamCard.propTypes = {
  authorAlt: PropTypes.string,
  authorSrc: PropTypes.string,
  authorName: PropTypes.element,
  authorPosition: PropTypes.element,
  review: PropTypes.element,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  textClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  infoContainerClassName: PropTypes.string,
  defaultName: PropTypes.string,
  defaultPosition: PropTypes.string,
  defaultReview: PropTypes.string
}

TeamCard.defaultProps = {
  className: '',
  containerClassName: '',
  infoContainerClassName: 'testimonial17-container13',
  imageClassName: 'testimonial17-image1',
  textClassName: 'testimonial17-text14',
  defaultName: '',
  defaultPosition: '',
  defaultReview: ''
}

export default TeamCard